import React, { Component } from "react";
import AntdSlider, {SliderProps} from 'antd/lib/slider';
import 'antd/lib/slider/style';

interface SProps extends SliderProps {
    forwardedRef?: any;
};
class Slider extends Component<SProps> {
    render() {
        const { forwardedRef, ...rest } = this.props;
        return (
          <AntdSlider ref={forwardedRef} {...rest} />
        )
    }
}
export default React.forwardRef((props: SProps, ref) => {
    return <Slider {...props} forwardedRef={ref} />
});




// WEBPACK FOOTER //
// ./src/components/slider/index.tsx